import React, {useMemo, useRef, useState} from 'react';
import dayjs from "dayjs";
import SearchParams from "../../shared/components/common/SearchParams";
import toast from "react-hot-toast";
import {Button} from "antd";
import {DownloadOutlined} from "@ant-design/icons";
import TablePage from "../../pages/tablePage/TablePage";

const AccountActivityLog = () => {
    const makeUrl = (isCSVStream) => {
        const {begin, end} = searchParam;

        return `logs/user_activity_list?begin=${begin}&end=${end}&isCSVStream=${isCSVStream || false}`;
    }

    const defaultSearchParams = useMemo(() => ({
        begin: dayjs().subtract(1, "week").startOf('day').format('YYYY-MM-DD HH:mm:ss'),
        end: dayjs().endOf('day').format('YYYY-MM-DD HH:mm:ss'),
        isUnix: false,
    }), []);

    const [searchParam, setSearchParam] = useState(defaultSearchParams);
    const [url, setUrl] = useState('');
    const [rowData, setRowData] = useState({});
    const [rows, setRows] = useState([]);
    const refreshRef = useRef(null);

    const handleSearchChange = (name, value) => {
        if (name === 'type' && value === '') {
            setSearchParam(defaultSearchParams);
        } else {
            setSearchParam(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleDownload = () => {
        const {begin, end} = searchParam;
        if (!begin || !end) {
            toast.error('시작일과 종료일을 모두 선택해주세요.');
            return;
        }

        window.location.href = process.env.REACT_APP_URL + makeUrl(true);
        toast.success('CSV 다운로드를 시작합니다...');
    };

    const handleSearch = () => {
        setUrl(makeUrl(false));
    };


    const columns = [
        {
            title: 'PID',
            dataIndex: 'pid',
            search: true,
        },
        {
            title: 'UserKey',
            dataIndex: 'userKey',
            search: true,
        },
        {
            title: 'Name',
            dataIndex: 'name',
            search: true,
        },
        {
            title: 'UDID',
            dataIndex: 'udid',
        },
        {
            title: '가입일',
            dataIndex: 'user_created',
        },
        {
            title: '최근 로그인',
            dataIndex: 'last_login',
        },
        {
            title: '국가',
            dataIndex: 'country',
        },
        {
            title: '최근 버전',
            dataIndex: 'version',
        },
        {
            title: 'OS',
            dataIndex: 'os',
        },
        {
            title: '최근 저장일',
            dataIndex: 'last_sync',
        }
    ];

    const props = {
        columns,
        rowData,
        setRowData,
        setRows,
        refreshRef,
        url,
        searchParam
    }
    return (
        <div>
            <SearchParams
                searchParam={searchParam}
                handleSetSearchParam={handleSearchChange}
                handleSearch={handleSearch}
            />
            <div style={{
                float: 'right',
                marginRight: 60,
                position: 'relative',
                zIndex: 1000
            }}>
                <Button
                    style={{
                        margin: 10,
                        backgroundColor: '#1890ff',
                        color: 'white',
                    }}
                    icon={<DownloadOutlined/>}
                    onClick={handleDownload}
                    disabled={searchParam.logType === 'log_admin'}
                >
                    CSV 다운로드
                </Button>
            </div>

            <TablePage {...props}/>
        </div>
    );
};

export default AccountActivityLog;